import { createApiActionType, createActionType } from 'app/store/utils';

const apiType = createApiActionType('filter');
const type = createActionType('filter');

export const OPEN_FILTER = type('OpenFilter');
export const CLOSE_FILTER = type('CloseFilter');
export const EDIT_FILTER = type('EditFilter');

/** @deprecated Use OPEN_FILTER */
export const OPEN_DIALOG = OPEN_FILTER;
/** @deprecated Use CLOSE_FILTER */
export const CLOSE_DIALOG = CLOSE_FILTER;

export const CREATE_FILTER = apiType('CreateFilter');
export const UPDATE_FILTER = apiType('UpdateFilter');

export const PREVIEW_FILTER = type('PreviewFilter');

export const SET_CURRENT_PARAMS = type('SetCurrentParams');
export const SET_FORM_VALID = type('SetFormValid');

export const CALCULATE_ROW_COUNTS = type('CalculateRowCounts');
